"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleTick.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleTick = function CircleTick(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 198.87 198.87"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Circle Tick Icon"), _react2.default.createElement("path", {
    d: "M99.43 0a99.44 99.44 0 1 0 99.44 99.44A99.43 99.43 0 0 0 99.43 0zm49 63.08L95.3 139.83c-6.26 10.1-8.31 10.7-8.44 10.76-3.26 1.59-8.91 1.32-11-1.22L50.5 118.18a6.75 6.75 0 0 1 1-9.47l6-4.84a6.75 6.75 0 0 1 9.47 1l14.58 18 50.5-73a6.71 6.71 0 0 1 9.4-1l6 4.9a6.7 6.7 0 0 1 .94 9.31z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CircleTick;